import { render } from "./BioResultFileEdit.vue?vue&type=template&id=129cb78d&scoped=true"
import script from "./BioResultFileEdit.vue?vue&type=script&lang=js"
export * from "./BioResultFileEdit.vue?vue&type=script&lang=js"

import "./BioResultFileEdit.vue?vue&type=style&index=0&id=129cb78d&lang=scss&scoped=true"
import "./BioResultFileEdit.vue?vue&type=style&index=1&id=129cb78d&lang=scss"
import "./BioResultFileEdit.vue?vue&type=style&index=2&id=129cb78d&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-129cb78d"]])

export default __exports__